import { VSelect } from 'vuetify/lib'
import commonMixins from './commonMixins'
import { defaultFun } from '../utils'
import { SELECT } from '../type_name'
export default {
    name: SELECT,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
                         slots,scopedSlots,
             key,
             _type = 'text',
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        params.type = _type
        return h(VSelect, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                'no-data-text':params.noDataText || '暂无数据',
                value: this.my_value[key]
            },
            on: {
                blur,
                change:(data) => {
                     this.my_value[key] = data
                    change(data)
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
            }
        })
    }
}